import { Bill } from '../types/bill'

export const bills: Bill[] = [
  {
    id: 'bill-1',
    vendor_company_id: 'wf',
    vendor_name: 'AWS',
    description: 'Cloud hosting services - January',
    total_amount: 450.0,
    due_date: new Date('2024-02-01'),
    paid: true,
    paid_date: new Date('2024-01-28'),
    allocations: [
      {
        id: 'alloc-1',
        company_id: 'tkd',
        company_name: 'TKDScore',
        amount: 200.0,
      },
      {
        id: 'alloc-2',
        company_id: 'magnus',
        company_name: 'Magnus',
        amount: 250.0,
      },
    ],
    created_at: new Date('2024-01-15'),
    updated_at: new Date('2024-01-28'),
  },
  {
    id: 'bill-2',
    vendor_company_id: 'wf',
    vendor_name: 'Adobe Creative Cloud',
    description: 'Design software subscription',
    total_amount: 79.99,
    due_date: new Date('2024-02-05'),
    paid: false,
    allocations: [
      {
        id: 'alloc-3',
        company_id: 'wf',
        company_name: 'Website Forge',
        amount: 79.99,
      },
    ],
    created_at: new Date('2024-01-20'),
    updated_at: new Date('2024-01-20'),
  },
  {
    id: 'bill-3',
    vendor_company_id: 'wf',
    vendor_name: 'Stripe',
    description: 'Payment processing fees',
    total_amount: 125.5,
    due_date: new Date('2024-02-10'),
    paid: false,
    allocations: [
      {
        id: 'alloc-4',
        company_id: 'tkd',
        company_name: 'TKDScore',
        amount: 75.0,
      },
      {
        id: 'alloc-5',
        company_id: 'magnus',
        company_name: 'Magnus',
        amount: 50.5,
      },
    ],
    created_at: new Date('2024-01-22'),
    updated_at: new Date('2024-01-22'),
  },
]
